import { PopoverContent } from 'ui/popover';
import styled from 'styled-components';
import { IconButton } from 'ui/button';

export const StyledMetadataList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
export const StyledMetadataListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-right: 7px;
`;
export const StyledProjectTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const StyledPopoverContent = styled(PopoverContent)`
  width: 400px !important;
  height: auto;
  position: absolute;
  left: -370px;
  top: 0;
  z-index: 100000;
  > * {
    width: 100%;
  }
  polygon {
    visibility: hidden;
  }
  align-self: left;
`;
export const StyledIconCont = styled.div`
  height: 25px !important;
  width: 25px !important;
`;
export const StyledIconButton = styled(IconButton)`
  align-self: center;
`;
